// extracted by mini-css-extract-plugin
var _1 = "ProfileInfoWidgetNotes-moduleProfileInfoWidgetNotes__biG1b";
export { _1 as "ProfileInfoWidgetNotes" }
